import { useQuery } from '@tanstack/react-query';
import { keys } from '@/lib/queryKeys';
import { fetchPurchaseOrder } from './api';

/** Enriched single PO — used only to pre-fill the "Mark Received" form. */
export function usePurchaseOrder(id: number | null) {
  return useQuery({
    queryKey: keys.procurement.purchaseOrder(id ?? 0),
    queryFn: () => fetchPurchaseOrder(id as number),
    enabled: id != null,
  });
}
